var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQMenuButton = function SvgQMenuButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.332,
    cy: 16,
    r: 2,
    fill: "#503CC8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 2,
    fill: "#503CC8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.668,
    cy: 16,
    r: 2,
    fill: "#503CC8"
  })));
};
export { SvgQMenuButton as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGVsbGlwc2UgY3g9IjcuMzMyMDMiIGN5PSIxNiIgcng9IjIiIHJ5PSIyIiBmaWxsPSIjNTAzQ0M4Ii8+CjxjaXJjbGUgY3g9IjE2IiBjeT0iMTYiIHI9IjIiIGZpbGw9IiM1MDNDQzgiLz4KPGNpcmNsZSBjeD0iMjQuNjY4IiBjeT0iMTYiIHI9IjIiIGZpbGw9IiM1MDNDQzgiLz4KPC9zdmc+Cg==";